export default __webpack_public_path__ + "static/media/ticket-group.a4f74fa8.png";